export enum OutputFormats {
  None = 0,
  Web = 1,
  Email = 2,
  PDF = 3,
  CSV = 4,
  XLSX = 5,
}
